import React from "react";

const NewSearchIcon = ({ size = 22, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9.818" cy="9.847" r="6.327" stroke={color} strokeWidth="1.5" />
    <path
      stroke={color}
      strokeLinecap="square"
      strokeWidth="1.5"
      d="m17.675 18.52-3.163-3.163"
    />
  </svg>
);

export default NewSearchIcon;
